var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.proforma
    ? _c(
        "div",
        [
          _c("v-app", [
            _vm.proforma
              ? _c("div", { staticClass: "dashboard-main-content" }, [
                  _c("div", { staticClass: "container-fluid" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12" }, [
                        _c("form", { attrs: { id: "agencyDetailFrom" } }, [
                          _c("div", { staticClass: "form-box" }, [
                            _c("div", { staticClass: "form-content pb-2" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-end p-3",
                                },
                                [
                                  _c("h3", { staticClass: "title" }, [
                                    _c("br"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "theme-btn",
                                      staticStyle: {
                                        "margin-right": "10px !important",
                                      },
                                      attrs: {
                                        disabled: !(
                                          _vm.proforma.agencyInvoices.filter(
                                            function (a) {
                                              return a.status == "new"
                                            }
                                          ).length == 0 &&
                                          _vm.proforma.agencyInvoices.filter(
                                            function (a) {
                                              return a.status == "paid"
                                            }
                                          ).length != 1
                                        ),
                                        type: "button",
                                      },
                                      on: { click: _vm.convertToInvoice },
                                    },
                                    [_vm._v("Proformayı Faturaya Çevir")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "theme-btn",
                                      attrs: {
                                        disabled: !(
                                          _vm.proforma.agencyInvoices.filter(
                                            function (a) {
                                              return a.status == "new"
                                            }
                                          ).length > 0
                                        ),
                                        type: "button",
                                      },
                                      on: { click: _vm.payInvoice },
                                    },
                                    [_vm._v("Proformayı Öde")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row justify-content-between" },
                                [
                                  _c("div", { staticClass: "col-lg-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "card-item p-3" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "contact-form-action",
                                          },
                                          [
                                            _c(
                                              "h3",
                                              { staticClass: "title mb-3" },
                                              [_vm._v("Proforma")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card-item row p-2 pl-3",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "label-text" },
                                                  [
                                                    _vm._v(
                                                      "Acente : " +
                                                        _vm._s(
                                                          _vm.proforma.agency
                                                            .name
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card-item row p-2 pl-3",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "label-text" },
                                                  [
                                                    _vm._v(
                                                      "Proforma Üretilme Tarihi : " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "ddMMyyyyHHmmSS"
                                                          )(
                                                            _vm.proforma
                                                              .agencyProforma
                                                              .createDate
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card-item row p-2 pl-3",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "label-text" },
                                                  [
                                                    _vm._v(
                                                      "Fatura Üretilme Tarihi :"
                                                    ),
                                                    _vm._l(
                                                      _vm.proforma
                                                        .agencyInvoices,
                                                      function (agencyInvoice) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "ddMMyyyyHHmmSS"
                                                                )(
                                                                  agencyInvoice.createDate
                                                                )
                                                              ) +
                                                              ", "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-lg-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "card-item p-3" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "contact-form-action",
                                          },
                                          [
                                            _c(
                                              "h3",
                                              { staticClass: "title mb-3" },
                                              [_vm._v("Belgeler")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card-item row p-2 pl-3",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "label-text" },
                                                  [
                                                    _vm._v(
                                                      "Proformayı İndir :\n                              "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "clickable-text",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downloadProforma(
                                                              _vm.proforma
                                                                .agencyProforma
                                                                .documentStoreId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                " +
                                                            _vm._s(
                                                              _vm.proforma
                                                                .agencyProforma
                                                                .invoiceId
                                                            ) +
                                                            "\n                              "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.proforma.agencyInvoices &&
                                            _vm.proforma.agencyInvoices.length >
                                              0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-item row p-2 pl-3",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "label-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Faturayı indir :\n                              "
                                                        ),
                                                        _vm._l(
                                                          _vm.proforma
                                                            .agencyInvoices,
                                                          function (
                                                            agencyInvoice
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "clickable-text",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.downloadInvoice(
                                                                        agencyInvoice.documentStoreId
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                " +
                                                                    _vm._s(
                                                                      agencyInvoice.invoiceId
                                                                    ) +
                                                                    "\n                              "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(
                                  "\n                    Rezervasyonlar\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-lg-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-item p-3" },
                                  [
                                    _c("agency-booking-list", {
                                      attrs: {
                                        "booking-list": _vm.bookingList,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-lg-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-item p-3" },
                                  [
                                    _c("agency-invoice-list", {
                                      attrs: {
                                        "invoice-list":
                                          _vm.proforma.agencyInvoices,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("pay-invoice-popup", {
            attrs: { invoices: _vm.proforma.agencyInvoices },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }